import { render } from "./tasks.vue?vue&type=template&id=3a4ca99c&ts=true"
import script from "./tasks.vue?vue&type=script&lang=ts"
export * from "./tasks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__